import React, { useState } from 'react';
// import { uploadImageToCloudinary } from '../../../../app/helper/functions';
import { JobFormProps } from '../../../../app/utlis/type';

const JobPostForm: React.FC<JobFormProps> = ({ onSubmit, initialData, isUpdating = false }) => {
  const [title, setTitle] = useState(initialData?.title || '');
  const [description, setDescription] = useState(initialData?.description || '');
  const [experience, setExperience] = useState(initialData?.experience || '');
  const [vacancy, setVacancy] = useState(initialData?.vacancy || '');
  const [location, setLocation] = useState(initialData?.location || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [imageFile, setImageFile] = useState<File | null>(null);
  // const [previewUrl, setPreviewUrl] = useState<string | null>(initialData?.imageUrl || null);
  const [errors, setErrors] = useState({
    title: '',
    // description: '',
    experience: '',
    vacancy: '',
    location: '',
    image: ''
  });

  // Handle image selection
  // const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const files = e.target.files;
  //   if (!files || files.length === 0) return;

  //   const file = files[0];
    
  //   // Check if file is an image
  //   if (!file.type.match('image.*')) {
  //     setErrors(prev => ({ ...prev, image: 'Please select an image file' }));
  //     return;
  //   }
    
  //   // Check file size (limit to 5MB)
  //   if (file.size > 5 * 1024 * 1024) {
  //     setErrors(prev => ({ ...prev, image: 'Image size should be less than 5MB' }));
  //     return;
  //   }

  //   setImageFile(file);
  //   setErrors(prev => ({ ...prev, image: '' }));
    
  //   // Create a preview
  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setPreviewUrl(reader.result as string);
  //   };
  //   reader.readAsDataURL(file);
  // };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      title: '',
      // description: '',
      experience: '',
      vacancy: '',
      location: '',
      image: ''
    };

    if (!title.trim()) {
      newErrors.title = 'Title is required';
      isValid = false;
    }

    // if (!description.trim()) {
    //   newErrors.description = 'Description is required';
    //   isValid = false;
    // }

    if (!experience.trim()) {
      newErrors.experience = 'Experience is required';
      isValid = false;
    }

    if (!vacancy.trim()) {
      newErrors.vacancy = 'Vacancy count is required';
      isValid = false;
    }

    if (!location.trim()) {
      newErrors.location = 'Location is required';
      isValid = false;
    }

    // // Only require image for new jobs, not when editing
    // if (!imageFile && !previewUrl) {
    //   newErrors.image = 'Please upload an image';
    //   isValid = false;
    // }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsSubmitting(true);

    // Create FormData to send files and other data
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('experience', experience);
    formData.append('vacancy', vacancy);
    formData.append('location', location);
    
    try {
      // Only upload a new image if the user selected a new one
      // if (imageFile && previewUrl && !previewUrl.startsWith('http')) {
      //   const imageUrl = await uploadImageToCloudinary(previewUrl);
      //   formData.append('imageUrl', imageUrl);
      // } else if (initialData?.imageUrl && !imageFile) {
      //   // If we're editing and no new image was selected, keep the old URL
      //   formData.append('imageUrl', initialData.imageUrl);
      // }
      
      // Call the parent's onSubmit function
      onSubmit(formData);
    } catch (error) {
      console.error('Error uploading image:', error);
      setErrors(prev => ({ ...prev, image: 'Failed to upload image. Please try again.' }));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-blackDarkTheme rounded-lg shadow-lg p-6">
      <h2 className="text-xl font-semibold mb-4 text-white">
        {initialData ? 'Edit Job Post' : 'Create New Job Post'}
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="title">
            Job Title *
          </label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              setErrors(prev => ({ ...prev, title: '' }));
            }}
            className="w-full px-3 py-2 border border-gray-600 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Enter job title"
          />
          {errors.title && <p className="mt-1 text-sm text-red-500">{errors.title}</p>}
        </div>

        <div className="mb-4">
          <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="description">
            Job Description
          </label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              // setErrors(prev => ({ ...prev, description: '' }));
            }}
            rows={5}
            className="w-full px-3 py-2 border border-gray-600 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Enter job description"
          />
          {/* {errors.description && <p className="mt-1 text-sm text-red-500">{errors.description}</p>} */}
        </div>

        <div className="mb-4">
          <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="experience">
            Experience *
          </label>
          <input
            id="experience"
            type="text"
            value={experience}
            onChange={(e) => {
              setExperience(e.target.value);
              setErrors(prev => ({ ...prev, experience: '' }));
            }}
            className="w-full px-3 py-2 border border-gray-600 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="e.g., 3+ years"
          />
          {errors.experience && <p className="mt-1 text-sm text-red-500">{errors.experience}</p>}
        </div>
        <div className="mb-4">
          <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="experience">
            Location *
          </label>
          <input
            id="location"
            type="text"
            value={location}
            onChange={(e) => {
              setLocation(e.target.value);
              setErrors(prev => ({ ...prev, location: '' }));
            }}
            className="w-full px-3 py-2 border border-gray-600 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="e.g., Surat, Bangalore, etc."
          />
          {errors.location && <p className="mt-1 text-sm text-red-500">{errors.location}</p>}
        </div>

        <div className="mb-4">
          <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="vacancy">
            Number of Vacancies *
          </label>
          <input
            id="vacancy"
            type="number"
            value={vacancy}
            onChange={(e) => {
              setVacancy(e.target.value);
              setErrors(prev => ({ ...prev, vacancy: '' }));
            }}
            className="w-full px-3 py-2 border border-gray-600 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Enter number of vacancies"
            min="1"
          />
          {errors.vacancy && <p className="mt-1 text-sm text-red-500">{errors.vacancy}</p>}
        </div>
        
        {/* Image Upload Field */}
        {/* <div className="mb-4">
          <label className="block text-gray-300 text-sm font-medium mb-2" htmlFor="image">
            Job Image
          </label>
          <div className="flex items-center space-x-4">
            <div className="flex-1">
              <input
                id="image"
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="hidden"
              />
              <label
                htmlFor="image"
                className="flex items-center justify-center px-4 py-2 border border-gray-600 rounded-md shadow-sm text-sm font-medium text-white bg-gray-700 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
              >
                {initialData?.imageUrl ? 'Change Image' : 'Browse Image'}
              </label>
            </div>
            {previewUrl && (
              <div className="w-24 h-24 relative">
                <img 
                  src={previewUrl} 
                  alt="Preview" 
                  className="w-full h-full object-cover rounded-md"
                />
                <button
                  type="button"
                  onClick={() => {
                    setImageFile(null);
                    setPreviewUrl(null);
                  }}
                  className="absolute -top-2 -right-2 bg-red-600 rounded-full p-1 text-white text-xs"
                >
                  ✕
                </button>
              </div>
            )}
          </div>
          {errors.image && <p className="mt-1 text-sm text-red-500">{errors.image}</p>}
          {imageFile && !previewUrl && (
            <p className="mt-1 text-sm text-gray-400">
              {imageFile.name} ({Math.round(imageFile.size / 1024)} KB)
            </p>
          )}
        </div> */}

        <div className="mt-6">
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
          >
            {isSubmitting
              ? isUpdating 
                ? 'Updating...' 
                : 'Publishing...'
              : isUpdating 
                ? 'Update Job Post'
                : 'Publish Job Post'
            }
          </button>
        </div>
      </form>
    </div>
  );
};

export default JobPostForm;